import React from 'react';
import { Mail } from 'lucide-react';

export default function TermsConditionsPage() {
  return (
    <div className="min-h-screen py-12 px-4" style={{ backgroundColor: '#FDFBF7' }}>
      <div className="max-w-4xl mx-auto">
        <article className="prose prose-lg max-w-none">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-primary mb-8" style={{ color: '#2C3E50' }}>
            Términos y Condiciones de Uso
          </h1>

          {/* Section 1 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              1. Objeto
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Las presentes condiciones regulan el acceso y uso del sitio web <a href="https://tantra-map.com" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline" style={{ color: '#D4A574' }}>https://tantra-map.com</a>, plataforma digital que funciona como <strong>directorio de profesionales y escuelas relacionadas con el tantra</strong>.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El acceso y uso del sitio implica la aceptación plena de estas condiciones por parte del usuario.
            </p>
          </section>

          {/* Section 2 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              2. Naturaleza de la plataforma
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Tantra Map es una plataforma digital cuya finalidad es ofrecer <strong>información y visibilidad a profesionales y escuelas del ámbito del tantra</strong>.
            </p>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              El sitio web funciona principalmente como <strong>directorio informativo y herramienta de contacto</strong> entre usuarios y profesionales.
            </p>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              El titular de la plataforma puede también desarrollar actividades profesionales relacionadas con el tantra fuera de la propia plataforma. En ese caso, dichas actividades se considerarán servicios independientes ofrecidos por el profesional correspondiente, bajo su propia responsabilidad.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              La plataforma Tantra Map <strong>no actúa como intermediario</strong> en la prestación de servicios entre usuarios y profesionales registrados en el directorio.
            </p>
          </section>

          {/* Section 3 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              3. Funcionamiento del servicio
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              La plataforma permite:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>buscar profesionales y escuelas relacionadas con el tantra</li>
              <li>consultar perfiles profesionales publicados en el directorio</li>
              <li>acceder a información de contacto de dichos profesionales</li>
            </ul>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Los usuarios pueden utilizar el sitio web sin necesidad de registrarse.
            </p>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Los profesionales y escuelas deben registrarse para publicar su perfil en el directorio.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Actualmente la plataforma <strong>no gestiona reservas ni pagos entre usuarios y profesionales</strong>.
            </p>
          </section>

          {/* Section 4 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              4. Registro de profesionales y escuelas
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Los profesionales y escuelas que deseen aparecer en el directorio deberán crear una cuenta y proporcionar la información requerida para su perfil.
            </p>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Al registrarse, los profesionales se comprometen a:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>proporcionar información veraz y actualizada</li>
              <li>no publicar información falsa o engañosa</li>
              <li>cumplir con la legislación aplicable en el ejercicio de su actividad</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular del sitio web se reserva el derecho de <strong>moderar, suspender o eliminar perfiles</strong> que incumplan estas condiciones.
            </p>
          </section>

          {/* Section 5 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              5. Contenido de los perfiles
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Los profesionales podrán publicar información relacionada con su actividad, incluyendo:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>fotografía de perfil</li>
              <li>biografía profesional</li>
              <li>especialidades</li>
              <li>años de experiencia</li>
              <li>datos de contacto</li>
              <li>información sobre su escuela o centro</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Parte de esta información será <strong>visible públicamente dentro del directorio</strong>.
            </p>
          </section>

          {/* Section 6 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              6. Responsabilidad de los profesionales
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Cada profesional o escuela es el único responsable de:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>la veracidad de la información publicada</li>
              <li>los servicios ofrecidos</li>
              <li>el cumplimiento de la normativa legal aplicable a su actividad</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular del sitio web no verifica ni garantiza la exactitud de los datos publicados por los profesionales.
            </p>
          </section>

          {/* Section 7 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              7. Relación entre usuarios y profesionales
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Cualquier contacto, acuerdo o servicio realizado entre usuarios y profesionales se establece <strong>directamente entre las partes</strong>.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular del sitio web <strong>no interviene en dichas relaciones</strong> ni actúa como intermediario en la prestación de los servicios.
            </p>
          </section>

          {/* Section 8 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              8. Limitación de responsabilidad
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              En la máxima medida permitida por la legislación aplicable, el titular del sitio web no será responsable de:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>la calidad de los servicios ofrecidos por profesionales registrados</li>
              <li>la exactitud o veracidad de la información publicada en los perfiles</li>
              <li>acuerdos o conflictos entre usuarios y profesionales</li>
              <li>daños directos o indirectos derivados del uso de la plataforma</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El uso del sitio web se realiza <strong>bajo la exclusiva responsabilidad del usuario</strong>.
            </p>
          </section>

          {/* Section 9 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              9. Prohibición de servicios sexuales
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              La plataforma no está destinada a la promoción de servicios sexuales, prostitución, escort o cualquier actividad de carácter sexual explícito.
            </p>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Los perfiles profesionales publicados en la plataforma deben referirse exclusivamente a actividades relacionadas con:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>bienestar</li>
              <li>desarrollo personal</li>
              <li>formación</li>
              <li>prácticas tradicionales relacionadas con el tantra</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular del sitio web se reserva el derecho de <strong>eliminar cualquier perfil o contenido que pueda interpretarse como oferta de servicios sexuales o que pueda vulnerar la legislación vigente</strong>.
            </p>
          </section>

          {/* Section 10 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              10. Uso adecuado de la plataforma
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Los usuarios se comprometen a utilizar el sitio web de forma responsable y conforme a la legislación vigente.
            </p>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Queda prohibido:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2" style={{ color: '#5D6D7E' }}>
              <li>utilizar la plataforma con fines ilegales</li>
              <li>publicar contenidos falsos o engañosos</li>
              <li>utilizar el sitio para actividades fraudulentas</li>
              <li>intentar acceder de forma no autorizada a sistemas informáticos del sitio</li>
            </ul>
          </section>

          {/* Section 11 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              11. Denuncia de contenidos
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Si cualquier usuario considera que un contenido publicado en la plataforma puede ser ilegal o inapropiado, podrá comunicarlo al titular mediante el correo electrónico:
            </p>
            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 inline-block mb-4">
              <a href="mailto:info@tantra-map.com" className="flex items-center gap-2 text-gold hover:underline font-semibold" style={{ color: '#D4A574' }}>
                <Mail className="h-5 w-5" />
                info@tantra-map.com
              </a>
            </div>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular analizará la solicitud y podrá retirar el contenido si lo considera necesario.
            </p>
          </section>

          {/* Section 12 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              12. Edad mínima
            </h2>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El uso de la plataforma está permitido únicamente a <strong>personas mayores de 18 años</strong>.
            </p>
          </section>

          {/* Section 13 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              13. Evolución del servicio
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              El titular del sitio web se reserva el derecho de modificar, actualizar o ampliar las funcionalidades de la plataforma en cualquier momento.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Esto puede incluir nuevas herramientas, servicios o funcionalidades, incluyendo en el futuro sistemas de promoción o suscripción para profesionales.
            </p>
          </section>

          {/* Section 14 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              14. Suspensión del servicio
            </h2>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular podrá suspender temporalmente el funcionamiento del sitio web por motivos técnicos, de mantenimiento o por causas de fuerza mayor.
            </p>
          </section>

          {/* Section 15 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              15. Legislación aplicable
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Las presentes condiciones se rigen por la legislación española vigente.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Para cualquier controversia que pudiera derivarse del uso del sitio web, las partes se someterán a los tribunales competentes en España.
            </p>
          </section>

        </article>
      </div>
    </div>
  );
}
